module.exports = __webpack_public_path__ + "img/wechat_light_hover.da5e1e29.svg";